// src/api/userProfileApi.js
import { customerProfileUrl, CUSTOMER_PROFILE_UPDATE_URL } from "../config/apiConfig";

const UPDATE_PROFILE_URL = CUSTOMER_PROFILE_UPDATE_URL;

// Fetch user profile — Commerce API GET /customer_profile/{customer_id}
// (2026-10-20; was the Cloud Function POST customer_profile { customer_id }).
// The reply is still an array with the one profile first.
export const fetchUserProfile = async (customerId) => {
  const response = await fetch(customerProfileUrl(customerId), { method: "GET" });

  if (!response.ok) {
    throw new Error(`Failed to fetch profile: ${response.status}`);
  }

  const data = await response.json();
  if (!Array.isArray(data) || data.length === 0) {
    throw new Error("No profile data found");
  }

  return data[0]; // API returns array with one object
};

// Update user profile — Commerce API POST /customer_profile_update, same body
// as the Cloud Function it replaced; replies { message, customer_id, updated_fields }.
export const updateUserProfile = async (profileData) => {
  const response = await fetch(UPDATE_PROFILE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(profileData),
  });

  if (!response.ok) {
    throw new Error(`Failed to update profile: ${response.status}`);
  }

  const result = await response.json();
  return result;
};